import React, { Component } from 'react';
import ReactLoading from 'react-loading';

class Loading extends Component {
  render() {

    const loadingStyle = {
      color: "#20a8d8",
      type: 'bubbles'
    };

    return (
      <ReactLoading { ...loadingStyle } />
    );
  }
};

export default Loading;


// WEBPACK FOOTER //
// ./src/views/Loading/Loading.js